import React, { useRef, useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CustomSelect, TextArea, TextInput } from "../../components";
import { addProduct, updateProduct } from "@/store/constants/constants.action";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../store";
import ImageUpload from "../ImageUpload/ImageUpload";
import { callRegisterMediaOnCms } from "@/store/upload/upload.action";
import { setCurrentProduct } from "@/store/constants/constants.slice";
import {
  getPresetList,
  getAdminPresetList,
  getUserBucketList,
} from "@/store/media/media.action";
import Search from "../../assets/icons/svg/search.svg?react";
import { toast } from "../../components";
import {
  User,
  Settings,
  SlidersHorizontal,
  Text,
  FolderTree,
} from "lucide-react";
import SidebarNavigation, {
  SidebarMenuItem,
} from "@/components/SidebarNavigation/SidebarNavigation";
import MetaDefault from "../../routes/pages/MetaDefault/MetaDefault";
import { getListAgencies } from "@/store/constants/constants.action";
import { discoverVisibilityOptions } from "@/utils/constants/utils";
import { formatEntityName } from "@/utils/utilFunctions/entityName";
import { getListUser } from "@/store/user/user.action";
import { truncateText } from "@/utils/utilFunctions/truncateText";
import ProductPolicies from "./ProductPolicies";
import BucketOrderManager from "./BucketOrderManager";
import { HOSTS } from "@/constants";

import {
  updateIsClearFilter,
  updateIsFilter,
} from "@/store/media/media.action";

import { createHostOptions } from "../../utils";
import { useDebounce } from "../../utils";
import { filterAdminPresetsByTeamsAndType } from "@/utils/mediautils/CommonFunctions";
interface AddProductFormProps {
  onClose: () => void;

  product?: any;
  onFormStateChange?: (state: {
    isDirty: boolean;
    isValid: boolean;
    isLoading: { error: boolean; success: boolean; loading: boolean };
  }) => void;

  category?: any;
}

export const AddProductForm = ({
  onClose,
  addProduct,
  updateProduct,
  callRegisterMediaOnCms,

  bunchBusinessList,
  bunchLanguageList,
  productList,
  setCurrentProduct,
  getListUser,
  currentProduct,
  onFormStateChange,
  updateIsFilter,
  updateIsClearFilter,
  category,
  getPresetList,
  presetList,
  getListAgencies,
  singleCurrentUser,
  hosts,
  denmarkHosts,
  adminPresetList,
  getAdminPresetList,
  bunchProductList,
  adminBucketList,
  getUserBucketList,
}: Props) => {
  const callback = useRef<((query: any, token: any) => void) | null>(null);
  const [productId, setProductId] = useState<string>("");
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [selectedMeta, setSelectedMeta] = useState<any>([]);
  const [metaList, setMetaList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState({
    error: false,
    success: false,
    loading: false,
  });
  const [logoUpdated, setLogoUpdated] = useState(true);
  const logoRef = useRef<any>({ value: "", baseurl: "" });
  const [activeSection, setActiveSection] = useState("basic-info");
  const [presetsLoading, setPresetsLoading] = useState(false);

  const basicInfoRef = useRef<HTMLDivElement>(null);
  const settingsRef = useRef<HTMLDivElement>(null);
  const presetsRef = useRef<HTMLDivElement>(null);
  const metaManagementRef = useRef<HTMLDivElement>(null);
  const bucketOrderRef = useRef<HTMLDivElement>(null);
  const [metaPresets, setMetaPresets] = useState<any[]>([]);
  const [processingPresets, setProcessingPresets] = useState<any[]>([]);
  const [brandingPresets, setBrandingPresets] = useState<any[]>([]);
  const [publishingPresets, setPublishingPresets] = useState<any[]>([]);

  const [selectedApprovers, setSelectedApprovers] = useState<any[]>([]);
  const [selectedAgency, setSelectedAgency] = useState<any[]>([]);

  const [autoSelectAgency, setAutoSelectAgency] = useState<any[]>([]);
  const [autoSelectApprovers, setAutoSelectApprovers] = useState<any[]>([]);

  const [approverSearchKeyword, setApproverSearchKeyword] =
    useState<string>("");
  const [agencySearchKeyword, setAgencySearchKeyword] = useState<string>("");

  const debouncedApproverKeyword = useDebounce(approverSearchKeyword, 200);
  const debouncedAgencyKeyword = useDebounce(agencySearchKeyword, 200);

  const [isLogoSet, setIsLogoSet] = useState(false);
  const [showMetaError, setShowMetaError] = useState(false);

  useEffect(() => {
    if (currentProduct) {
      const approvers = currentProduct?.userdata?.map((approver: any) => ({
        label: ` ${approver?.name}  ${
          approver?.email ? "(" + truncateText(approver?.email, 50) + ")" : ""
        } `,
        value: approver?.id,
      }));

      setSelectedApprovers(approvers);

      const agency = [
        {
          label: formatEntityName(currentProduct?.agencydata),
          value: currentProduct?.agencydata?.id,
        },
      ];
      setSelectedAgency(agency);
    }
  }, [currentProduct]);

  useEffect(() => {
    if (debouncedApproverKeyword.length >= 3) {
      getListUser?.({ name: debouncedApproverKeyword, setInRedux: false }).then(
        (res: any) => {
          setAutoSelectApprovers(res || []);
        }
      );
    } else {
      getListUser?.({ name: "", setInRedux: false }).then((res: any) => {
        setAutoSelectApprovers(res || []);
      });
    }
  }, [debouncedApproverKeyword, getListUser]);

  useEffect(() => {
    if (debouncedAgencyKeyword.length >= 3) {
      getListAgencies?.({
        name: debouncedAgencyKeyword,
        setInRedux: false,
      }).then((res: any) => {
        setAutoSelectAgency(res || []);
      });
    } else {
      getListAgencies?.({ name: "", setInRedux: false }).then((res: any) => {
        setAutoSelectAgency(res || []);
      });
    }
  }, [debouncedAgencyKeyword, getListAgencies]);

  const [metaData, setMetaData] = useState<any>({
    language: [],
    category: [],
  });
  const [initialMetaData, setInitialMetaData] = useState<any>({
    language: [],
    category: [],
  });

  // Define sidebar menu items
  const sidebarMenuItems: SidebarMenuItem[] = [
    {
      id: "basic-info",
      label: "Basic Information",
      icon: User,
      sectionRef: basicInfoRef,
    },
    {
      id: "settings",
      label: "Settings",
      icon: Settings,
      sectionRef: settingsRef,
    },
    {
      id: "presets",
      label: "Presets",
      icon: SlidersHorizontal,
      sectionRef: presetsRef,
    },
    {
      id: "meta-management",
      label: "Meta Management",
      icon: Text,
      sectionRef: metaManagementRef,
    },
    {
      id: "bucket-order",
      label: "Bucket Order",
      icon: FolderTree,
      sectionRef: bucketOrderRef,
    },
  ];

  useEffect(() => {
    const fetchPresets = async () => {
      setPresetsLoading(true);
      try {
        await getAdminPresetList({
          keys: ["meta_preset", "publish_preset"],
          status: "active",
        });
      } catch (error) {
        console.error("Error fetching presets:", error);
      } finally {
        setPresetsLoading(false);
      }
    };

    fetchPresets();
  }, []);

  // Fetch buckets for the bucket order manager
  useEffect(() => {
    if (!singleCurrentUser?.team) return;
    getUserBucketList({ team: currentProduct?.id, status: 1 });
  }, [getUserBucketList, singleCurrentUser?.team]);

  // const metaPresets: any[] = [];
  // const processingPresets: any[] = [];
  // const brandingPresets: any[] = [];
  // const publishingPresets: any[] = [];

  // (presetList || []).forEach((preset: any) => {
  //   if (preset.status !== 1) return;

  //   switch (preset.type) {
  //     case "meta":
  //       metaPresets.push(preset);
  //       break;
  //     case "processing":
  //       processingPresets.push(preset);
  //       break;
  //     case "branding":
  //       brandingPresets.push(preset);
  //       break;
  //     case "social":
  //       publishingPresets.push(preset);
  //       break;
  //     default:
  //       break;
  //   }
  // });
  useEffect(() => {
    if (
      adminPresetList?.meta_preset &&
      adminPresetList?.meta_preset?.length > 0
    ) {
      const metaPresets = filterAdminPresetsByTeamsAndType(
        bunchProductList,
        adminPresetList,
        "meta_preset"
      );
      setMetaPresets(metaPresets);
    }
  }, [adminPresetList, bunchProductList]);

  useEffect(() => {
    if (
      adminPresetList?.publish_preset &&
      adminPresetList?.publish_preset?.length > 0
    ) {
      const publishingPresets = filterAdminPresetsByTeamsAndType(
        bunchProductList,
        adminPresetList,
        "publish_preset"
      );
      setPublishingPresets(publishingPresets);
    }
  }, [adminPresetList, bunchProductList]);

  const businessOptions = bunchBusinessList.map((business: any) => ({
    label: formatEntityName(business),
    value: business?.id,
  }));

  const handleApiError = (error: any) => {
    if (typeof error === "string") {
      const fieldErrors: Record<string, string> = {};
      if (error.toLowerCase().includes("name")) {
        fieldErrors.name = error;
      } else if (error.toLowerCase().includes("code")) {
        fieldErrors.code = error;
      }
      if (Object.keys(fieldErrors).length > 0) {
        formik.setErrors(fieldErrors);
        toast.fail("");
      }
    } else if (error?.response?.data?.message) {
      toast.fail("");
    } else {
      toast.fail("");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: currentProduct?.name || "",
      code: currentProduct?.code || "",
      desc: currentProduct?.desc || "",
      business: currentProduct?.business || "",
      status: currentProduct?.archive ? 2 : 1,
      approvers: currentProduct?.approvers || [],
      logo: currentProduct?.logo || "",
      contributor_policy: {
        producer: currentProduct?.contributor_policy?.producer || 2,
        anchor: currentProduct?.contributor_policy?.anchor || 2,
        editor: currentProduct?.contributor_policy?.editor || 2,
        script_writer: currentProduct?.contributor_policy?.script_writer || 2,
        cameraman: currentProduct?.contributor_policy?.cameraman || 2,
        photographer: currentProduct?.contributor_policy?.photographer || 2,
        researcher: currentProduct?.contributor_policy?.researcher || 2,
        compiler: currentProduct?.contributor_policy?.compiler || 2,
        curator: currentProduct?.contributor_policy?.curator || 2,
        reporter: currentProduct?.contributor_policy?.reporter || 2,
        author: currentProduct?.contributor_policy?.author || 2,
      },
      credits_policy: {
        imagecredit: currentProduct?.credits_policy?.imagecredit || 2,
        videocredit: currentProduct?.credits_policy?.videocredit || 2,
        audiocredit: currentProduct?.credits_policy?.audiocredit || 2,
      },
      geo_policy: {
        gcl: currentProduct?.geo_policy?.gcl || 2,
        gct: currentProduct?.geo_policy?.gct || 2,
      },
      tags_policy: currentProduct?.tags_policy || 3,
      agency_credit_policy: currentProduct?.agency_credit_policy || 2,
      ctype_policy: currentProduct?.ctype_policy || 3,
      desc_policy: currentProduct?.desc_policy || 3,
      title_for_url_policy: currentProduct?.title_for_url_policy || 3,
      production_type_policy: currentProduct?.production_type_policy || 3,
      content_rating_policy: currentProduct?.content_rating_policy || 2,
      sub_category_policy: currentProduct?.sub_category_policy || 2,
      team_policy: currentProduct?.team_policy || 3,
      agency_policy: currentProduct?.agency_policy || 3,
      category_policy: currentProduct?.category_policy || 3,
      language_policy: currentProduct?.language_policy || 2,
      expiry_policy: currentProduct?.expiry_policy || 2,
      youtube_id_policy: currentProduct?.youtube_id_policy || 2,
      parentid_policy: currentProduct?.parentid_policy || 2,
      settings: {
        language: currentProduct?.settings?.language || "",
        agency: currentProduct?.settings?.agency || "",
        host: currentProduct?.settings?.host || "",
        notification: {
          notifyUpload:
            currentProduct?.settings?.notification?.notifyUpload || false,
          notifyReady:
            currentProduct?.settings?.notification?.notifyReady || false,
        },
        discover: {
          visibility: currentProduct?.settings?.discover?.visibility || 1,
        },
      },
      meta: {
        category: currentProduct?.meta?.category || [],
        language: currentProduct?.meta?.language || [],
      },
      presets: {
        meta: currentProduct?.presets?.meta || "",
        processing: currentProduct?.presets?.processing || "",
        branding: currentProduct?.presets?.branding || "",
        social: currentProduct?.presets?.social || "",
      },
      tags: currentProduct?.tags || "hide",
      bucket_order: currentProduct?.bucket_order || [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Team Name is required"),
      code: Yup.string().required("Team Code is required"),
      business: Yup.string().required("Team is required"),
      approvers: Yup.array()
        .min(1, "At least one approver is required")
        .required("Approvers are required"),
      settings: Yup.object({
        language: Yup.string().required("Language is required"),
        agency: Yup.string().required("Agency is required"),
        host: Yup.string().required("Host is required"),
      }),
    }),
    onSubmit: async (values) => {
      try {
        const onSuccess = (response: any) => {
          const newProductList = [response, ...productList];
          const productId = response?.id;
          setProductId(productId);

          uploadLogo(response?.id, newProductList);
          const successMessage = currentProduct
            ? "Team updated successfully"
            : "Team created successfully";
          toast.success(successMessage);
        };

        const uploadLogo = (id: string, pList: any) => {
          const productId = currentProduct ? currentProduct?.id : id;
          if (selectedImage && callback.current != null) {
            setLogoUpdated(true);
            callRegisterMediaOnCms(selectedImage, (response: any) => {
              if (response && response.status === 200) {
                const token = response.data.jwt;
                const query = {
                  entity: productId,
                  key: "logo",
                };
                callback.current && callback.current(query, token);
                const updatedProduct = pList.filter(
                  (product: any) => product.id === productId
                );
                const ub = { ...updatedProduct[0] };
                setCurrentProduct(ub);
              } else {
                handleApiError(response.error);
                toast.fail("");
              }
            });
          } else {
            setLogoUpdated(false);
            logoRef.current.value = "";
          }
        };

        if (currentProduct) {
          if (selectedMeta.length > 0) {
            const updatedMeta = selectedMeta.map((item: any) => item.id);
            const { status, ...restValues } = values;
            const params = {
              ...restValues,
              meta: metaData,
              // archive: values.status === 2 ? 1 : 0,
              id: currentProduct?.id,
            };
            await updateProduct(params, onSuccess, handleApiError);
          } else {
            const { status, ...restValues } = values;
            const params = {
              ...restValues,
              meta: metaData,
              // archive: values.status === 2 ? 1 : 0,
              id: currentProduct?.id,
            };
            await updateProduct(params, onSuccess, handleApiError);
          }
        } else {
          updateIsClearFilter && updateIsClearFilter(true);
          updateIsFilter && updateIsFilter(false);
          const params = { ...values, meta: metaData };
          await addProduct(params, onSuccess, handleApiError);
        }
      } catch (error) {
        handleApiError(error);
      }
    },
  });

  const handleChange = (values: string[]) => {
    const newApprovers = values.map((value) => {
      const existingApprover = formik.values.approvers.find(
        (approver: string) => approver.startsWith(value)
      );
      return existingApprover ? existingApprover : value;
    });
    formik.setFieldValue("approvers", newApprovers);
  };

  // Check if meta data has changed
  const isMetaDataChanged = () => {
    const currentLanguage = metaData.language || [];
    const currentCategory = metaData.category || [];
    const initialLanguage = initialMetaData.language || [];
    const initialCategory = initialMetaData.category || [];

    // Check if arrays are different lengths
    if (
      currentLanguage.length !== initialLanguage.length ||
      currentCategory.length !== initialCategory.length
    ) {
      return true;
    }

    // Check if language arrays have different content
    const languageChanged =
      currentLanguage.some((id: any) => !initialLanguage.includes(id)) ||
      initialLanguage.some((id: any) => !currentLanguage.includes(id));

    // Check if category arrays have different content
    const categoryChanged =
      currentCategory.some((id: any) => !initialCategory.includes(id)) ||
      initialCategory.some((id: any) => !currentCategory.includes(id));

    return languageChanged || categoryChanged;
  };

  useEffect(() => {
    onFormStateChange?.({
      isDirty: formik.dirty || isMetaDataChanged(),
      isValid: formik.isValid,
      isLoading: isLoading,
    });
  }, [
    formik.dirty,
    formik.isValid,
    isLoading,
    metaData,
    initialMetaData,
    onFormStateChange,
  ]);

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    formik.setTouched({
      approvers: true,
      name: true,
      code: true,
      business: true,
      settings: {
        language: true,
        agency: true,
        host: true,
      },
    });

    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      return;
    }
    if (metaData.language.length === 0 || metaData.category.length === 0) {
      setShowMetaError(true);
      toast.fail("Please select at least one language and one category");
      // Scroll to meta management section
      if (metaManagementRef.current) {
        metaManagementRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setActiveSection("meta-management");
      return;
    }
    setShowMetaError(false);
    await formik.handleSubmit();
  };

  useEffect(() => {
    if (logoRef.current.value) {
      const updatedProduct = productList.find(
        (product: any) => product.id === currentProduct?.id
      );
      if (updatedProduct) {
        setCurrentProduct({
          ...updatedProduct,
          logo: logoRef.current.value,
          baseurl: logoRef.current.baseurl,
        });
      }
    }

    setIsLogoSet(true);
  }, [logoRef.current.value]);

  useEffect(() => {
    if (isLoading.success || !logoUpdated) {
      if (isLogoSet) {
        onClose();
      }
    }
  }, [isLoading, logoUpdated, isLogoSet]);

  useEffect(() => {
    const handleSubmit = (e: any) => {
      e.preventDefault();
      handleFormSubmit(e);
    };
    window.addEventListener("submit", handleSubmit);
    return () => {
      window.removeEventListener("submit", handleSubmit);
    };
  }, [handleFormSubmit]);

  useEffect(() => {
    if (category) {
      setMetaList(category);
    }
  }, [category]);

  // Reset meta error when meta data becomes valid
  useEffect(() => {
    if (
      showMetaError &&
      metaData.language.length > 0 &&
      metaData.category.length > 0
    ) {
      setShowMetaError(false);
    }
  }, [metaData, showMetaError]);

  const hostOptions = [
    { label: "No Denmark Host", value: "none", logoStyle: {} },
    ...createHostOptions(HOSTS, denmarkHosts),
  ];

  const hostOptionRenderer = (option: any) => (
    <div className="d-flex align-items-center" style={{ maxWidth: "180px" }}>
      {option.logoStyle && Object.keys(option.logoStyle).length > 0 && (
        <div style={option.logoStyle} />
      )}
      <span
        className={
          option.logoStyle && Object.keys(option.logoStyle).length > 0
            ? "ms-2 text-truncate"
            : "text-truncate"
        }
        style={{ maxWidth: "140px" }}
      >
        {option.label}
      </span>
    </div>
  );

  // Initialize meta data for tracking changes
  useEffect(() => {
    if (currentProduct?.meta) {
      const initialMeta = {
        language: currentProduct.meta.language || [],
        category: currentProduct.meta.category || [],
      };
      setInitialMetaData(initialMeta);
      setMetaData(initialMeta);
    } else {
      const initialMeta = {
        language: [],
        category: [],
      };
      setInitialMetaData(initialMeta);
      setMetaData(initialMeta);
    }
  }, [currentProduct]);

  useEffect(() => {
    if (formik.values.settings.language && metaData.language?.length > 0) {
      const languageId = bunchLanguageList.find(
        (item: any) => item.name === formik.values.settings.language
      )?.id;
      if (languageId && !metaData.language.includes(languageId)) {
        formik.setFieldValue("settings.language", "");
      }
    }
  }, [formik.values.settings.language, bunchLanguageList, metaData.language]);

  return (
    <div className="mx-2 my-3 row">
      <SidebarNavigation
        menuItems={sidebarMenuItems}
        activeItem={activeSection}
        onItemClick={setActiveSection}
        className="col-sm-5 col-md-4 col-lg-3 sticky-top sidebar-top"
      />
      <form className="col-sm-7 col-md-8 col-lg-9 gap-3" id="productForm">
        <div ref={basicInfoRef} className="card mx-0 mb-4 pb-3">
          <div className="card-header py-3 bg-light border-0">
            <h6 className="text-uppercase">Basic Information</h6>
          </div>
          <div className="row p-2 gy-2 m-0">
            <div className="col-12">
              <div className="row m-0 gy-2">
                <div className="col-3 ps-0">
                  <ImageUpload
                    id={productId}
                    registerMedia={callRegisterMediaOnCms}
                    setSelectedImage={(image: File | null) => {
                      setSelectedImage(image);
                      formik.setFieldValue("logo", Date.now().toString());
                    }}
                    callbackRef={callback}
                    logoRef={logoRef}
                    type="team"
                    logo={
                      currentProduct?.logo
                        ? `${currentProduct.baseurl}/${currentProduct.logo}.jpg`
                        : ""
                    }
                    hasBaseUrl={currentProduct?.baseurl}
                    setIsLoading={setIsLoading}
                  />
                </div>
                <div className="col-9 row m-0 gy-2 pe-0">
                  <div className="col-12 pe-0">
                    <TextInput
                      name="name"
                      type="text"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      label="Title"
                      placeholder="Enter Team Name"
                      onBlur={formik.handleBlur}
                      showRequired={true}
                      error={formik.errors.name as string}
                      touched={formik.touched.name as boolean}
                    />
                  </div>
                  <div className="col-12 pe-0">
                    <TextInput
                      name="code"
                      value={formik.values.code}
                      onChange={formik.handleChange}
                      placeholder="Enter Team Code"
                      onBlur={formik.handleBlur}
                      label="Code"
                      showRequired={true}
                      error={formik.errors.code as string}
                      touched={formik.touched.code as boolean}
                      disabled={currentProduct}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <CustomSelect
                value={String(formik.values.business)}
                label="Business"
                name="business"
                options={businessOptions}
                disabled={false}
                showRequired={true}
                placeholder="Select Business"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("business", newValue.value);
                }}
                error={formik.errors.business as string}
                touched={formik.touched.business as boolean}
                updatedOptions={businessOptions}
              />
            </div>
            <div className="col-md-6 H">
              <CustomSelect
                value={formik.values.status}
                label="Status"
                name="status"
                options={[
                  { label: "Active", value: 1 },
                  { label: "Inactive", value: 2 },
                ]}
                disabled={false}
                placeholder="Select Status"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("status", newValue.value);
                }}
              />
            </div>
            <div className="col-12">
              <TextArea
                name="desc"
                value={formik.values.desc}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Description"
                showRequired={false}
                placeholder="Enter Description Here..."
              />
            </div>
            <div className="col col-12">
              <CustomSelect
                value={formik.values.approvers}
                label="Approvers"
                name="approvers"
                options={
                  autoSelectApprovers?.map((user: any) => ({
                    label: ` ${user?.name}  ${
                      user?.email
                        ? "(" + truncateText(user?.email, 50) + ")"
                        : ""
                    } `,
                    value: user.id,
                  })) || []
                }
                multiSelect={true}
                disabled={false}
                showRequired={true}
                loader={true}
                placeholder={
                  <div className="d-flex align-items-center gap-1">
                    <Search style={{ width: "14px", height: "14px" }} />
                    Search Approvers
                  </div>
                }
                handleChange={(newValue: any) => {
                  handleChange(newValue.map((option: any) => option.value));
                }}
                onInputChangeCallback={(params) => {
                  setApproverSearchKeyword(params.keyword);
                }}
                error={formik.errors.approvers as string}
                touched={formik.touched.approvers as boolean}
                updatedOptions={
                  autoSelectApprovers?.map((user: any) => ({
                    label: ` ${user?.name}  ${
                      user?.email
                        ? "(" + truncateText(user?.email, 50) + ")"
                        : ""
                    } `,
                    value: user.id,
                  })) || []
                }
                creditData={selectedApprovers}
              />
            </div>
            <div className="col-md-12">
              <h6 className="border-bottom my-3 pb-2">Default Meta</h6>
              <div className="row m-0">
                <div className="col-md-6 ps-0">
                  <CustomSelect
                    value={formik.values.settings.language}
                    label="Language"
                    name="settings.language"
                    options={bunchLanguageList.map((language: any) => ({
                      label: language?.name,
                      value: language?.name,
                    }))}
                    disabled={false}
                    showRequired={true}
                    placeholder="Select Language"
                    handleChange={(newValue: any) => {
                      formik.setFieldValue("settings.language", newValue.value);
                      const langId = bunchLanguageList.find(
                        (item: any) => item.name === newValue.value
                      )?.id;
                      if (metaData.language.includes(langId)) {
                        return;
                      }
                      setMetaData({
                        ...metaData,
                        language: [
                          bunchLanguageList.find(
                            (item: any) => item.name === newValue.value
                          )?.id,
                        ],
                      });
                      formik.setFieldValue("meta.language", [
                        ...metaData.language,
                        bunchLanguageList.find(
                          (item: any) => item.name === newValue.value
                        )?.id,
                      ]);
                    }}
                    error={formik.errors.settings?.language as string}
                    touched={formik.touched.settings?.language as boolean}
                    updatedOptions={bunchLanguageList.map((language: any) => ({
                      label: language?.name,
                      value: language?.name,
                    }))}
                  />
                </div>
                <div className="col-md-6 pe-0">
                  <CustomSelect
                    value={formik.values.settings.agency}
                    label="Agency"
                    name="settings.agency"
                    options={autoSelectAgency?.map((agency: any) => ({
                      label: formatEntityName(agency),
                      value: agency?.id,
                    }))}
                    disabled={false}
                    showRequired={true}
                    placeholder="Select Agency"
                    onInputChangeCallback={(params) => {
                      setAgencySearchKeyword(params.keyword);
                    }}
                    updatedOptions={autoSelectAgency?.map((agency: any) => ({
                      label: formatEntityName(agency),
                      value: agency?.id,
                    }))}
                    handleChange={(newValue: any) =>
                      formik.setFieldValue("settings.agency", newValue.value)
                    }
                    creditData={selectedAgency}
                    error={formik.errors.settings?.agency as string}
                    touched={formik.touched.settings?.agency as boolean}
                    loader={true}
                  />
                </div>
                <div className="col-md-6 ps-0" style={{ marginTop: "10px" }}>
                  {/* <CustomSelect
                    value={formik.values.settings.host}
                    label="Denmark Host"
                    name="settings.host"
                    options={hosts.map((host: any) => ({
                      label: host?.name,
                      value: host?.id,
                    }))}
                    disabled={currentProduct?.settings?.host}
                    placeholder="Select Hosts"
                    handleChange={(newValue: any) => formik.setFieldValue('settings.host', newValue.value)}
                  /> */}
                  <CustomSelect
                    name="settings.host"
                    label="Denmark Host"
                    placeholder="Select Host"
                    value={formik.values.settings.host}
                    handleChange={(newValue: any) =>
                      formik.setFieldValue("settings.host", newValue.value)
                    }
                    options={hostOptions}
                    ishost={true}
                    hideArrow={true}
                    customOptionRenderer={hostOptionRenderer}
                    updatedOptions={hostOptions}
                    showRequired={true}
                    error={formik.errors.settings?.host as string}
                    touched={formik.touched.settings?.host as boolean}
                    // customValueRenderer={hostValueRenderer}
                    // menuWidth="200px"
                    // menuAlign="extend-right"
                    // isMenuWidthFixed={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref={settingsRef} className="card mx-0 mb-4">
          <div className="card-header py-3 bg-light border-0">
            <h6 className="text-uppercase">Settings</h6>
          </div>
          <div className="row m-0 p-3">
            <div className="col-6 border-end">
              <div className="text-uppercase text-secondary mb-3 fw-medium">
                Discover
              </div>
              <CustomSelect
                value={formik.values.settings.discover.visibility}
                label="Visibility"
                name="settings.discover.visibility"
                options={discoverVisibilityOptions}
                disabled={false}
                placeholder="Select Visibility"
                className="me-3"
                handleChange={(newValue: any) => {
                  formik.setFieldValue(
                    "settings.discover.visibility",
                    newValue.value
                  );
                }}
              />
            </div>
            <div className="col-6">
              <div className="text-uppercase text-secondary mb-3 fw-medium">
                Notification
              </div>
              <div>
                <div className="form-check ms-3 mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="notifyUpload"
                    checked={
                      formik.values.settings?.notification?.notifyUpload ||
                      false
                    }
                    onChange={(e) =>
                      formik.setFieldValue(
                        "settings.notification.notifyUpload",
                        e.target.checked
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="notifyUpload">
                    Notify me when uploaded.
                  </label>
                </div>
                <div className="form-check ms-3 mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="notifyReady"
                    checked={
                      formik.values.settings?.notification?.notifyReady || false
                    }
                    onChange={(e) =>
                      formik.setFieldValue(
                        "settings.notification.notifyReady",
                        e.target.checked
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="notifyReady">
                    Notify me when ready.
                  </label>
                </div>
              </div>
            </div>
          </div>
          <ProductPolicies formik={formik} />
        </div>
        <div ref={presetsRef} className="card mx-0 mb-4">
          <div className="card-header py-3 bg-light border-0">
            <h6 className="text-uppercase">Presets</h6>
          </div>
          <div className="row m-0 p-3 gy-3 pt-0">
            <div className="col-6">
              <CustomSelect
                value={formik.values.presets.meta || ""}
                label="Meta"
                name="presets.meta"
                options={[
                  { label: "None", value: "" },
                  ...metaPresets.map((preset: any) => ({
                    label: preset.name,
                    value: preset.id,
                  })),
                ]}
                disabled={presetsLoading}
                placeholder={
                  presetsLoading ? "Loading..." : "Select Meta Preset"
                }
                handleChange={(newValue: any) => {
                  formik.setFieldValue("presets.meta", newValue.value);
                }}
              />
            </div>
            {/* <div className="col-6">
              <CustomSelect
                value={formik.values.presets.processing || ""}
                label="Processing"
                name="presets.processing"
                options={[
                  { label: "None", value: "" },
                  ...processingPresets.map((preset: any) => ({
                    label: preset.name,
                    value: preset.id,
                  })),
                ]}
                disabled={presetsLoading}
                placeholder={
                  presetsLoading ? "Loading..." : "Select Processing Preset"
                }
                handleChange={(newValue: any) => {
                  formik.setFieldValue("presets.processing", newValue.value);
                }}
              />
            </div> */}
            {/* <div className="col-6">
              <CustomSelect
                value={formik.values.presets.branding || ""}
                label="Branding"
                name="presets.branding"
                options={[
                  { label: "None", value: "" },
                  ...brandingPresets.map((preset: any) => ({
                    label: preset.name,
                    value: preset.id,
                  })),
                ]}
                disabled={presetsLoading}
                placeholder={
                  presetsLoading ? "Loading..." : "Select Branding Preset"
                }
                handleChange={(newValue: any) => {
                  formik.setFieldValue("presets.branding", newValue.value);
                }}
              />
            </div> */}
            <div className="col-6">
              <CustomSelect
                value={formik.values.presets.social || ""}
                label="Publishing"
                name="presets.social"
                options={[
                  { label: "None", value: "" },
                  ...publishingPresets.map((preset: any) => ({
                    label: preset.name,
                    value: preset.id,
                  })),
                ]}
                disabled={presetsLoading}
                placeholder={
                  presetsLoading ? "Loading..." : "Select Publishing Preset"
                }
                handleChange={(newValue: any) => {
                  formik.setFieldValue("presets.social", newValue.value);
                }}
              />
            </div>
          </div>
        </div>

        <div ref={bucketOrderRef} className="card mx-0 mb-4">
          <div className="card-header py-3 bg-light">
            <h6 className="text-uppercase">Bucket Order Management</h6>
            <small className="text-muted">
              Define the display order of buckets for this team
            </small>
          </div>
          <div className="p-3">
            <BucketOrderManager
              buckets={adminBucketList}
              initialOrder={formik.values.bucket_order}
              onChange={(orderedIds) => {
                formik.setFieldValue("bucket_order", orderedIds);
              }}
              label="Bucket Display Order"
              currentProduct={currentProduct}
            />
          </div>
        </div>

        <div ref={metaManagementRef} className="card mx-0 mb-4">
          <div className="card-header py-3 bg-light">
            <h6 className="text-uppercase">
              Meta Management <span style={{ color: "red" }}>*</span>
            </h6>
            {showMetaError &&
              (metaData.language.length === 0 ||
                metaData.category.length === 0) && (
                <div className="mt-2">
                  <span style={{ color: "red", fontWeight: "500" }}>
                    Please select at least one language and one category
                  </span>
                </div>
              )}
          </div>
          <div className="p-3">
            <MetaDefault
              isFromProductForm={true}
              preSelectedMetaLanguage={formik.values.meta.language}
              preSelectedMetaCategory={formik.values.meta.category}
              onMetaChange={(selectedMeta) => {
                setMetaData(selectedMeta);
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

const mapState = (state: RootState) => ({
  bunchBusinessList: state.constants.bunchBusinessList.list,
  productList: state.constants.productList.list,
  bunchProductList: state.constants.bunchProductList.list,
  bunchLanguageList: state.constants.bunchLanguageList.list,
  currentProduct: state.constants.currentProduct,
  presetList: state.media.presetList.list,
  agencyList: state.constants.agenciesList.list,
  singleCurrentUser: state.users.singleCurrentUser,
  userListOptions: state.users.userList.list,
  hosts: state.media.hostList.list,
  adminPresetList: state.media.adminPresetList.list,
  adminBucketList: state.media.adminBucketList.list,
  denmarkHosts:
    state.constants.allHostsList.list &&
    Array.isArray((state.constants.allHostsList.list as any)?.hosts)
      ? ((state.constants.allHostsList.list as any)?.hosts as any[])
      : Array.isArray(state.constants.allHostsList.list)
        ? (state.constants.allHostsList.list as any[])
        : [],
});
const mapDispatch = {
  addProduct,
  updateProduct,

  callRegisterMediaOnCms,

  setCurrentProduct,
  getListAgencies,
  getPresetList,
  getListUser,
  updateIsClearFilter,
  updateIsFilter,
  getAdminPresetList,
  getUserBucketList,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector> & AddProductFormProps;

export default connector(AddProductForm);
